import { render, staticRenderFns } from "./PickTicketStatus.vue?vue&type=template&id=00bbaee9&scoped=true"
import script from "./PickTicketStatus.vue?vue&type=script&lang=ts"
export * from "./PickTicketStatus.vue?vue&type=script&lang=ts"
import style0 from "./PickTicketStatus.vue?vue&type=style&index=0&id=00bbaee9&prod&lang=scss&scoped=true"
import style1 from "./PickTicketStatus.vue?vue&type=style&index=1&id=00bbaee9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbaee9",
  null
  
)

export default component.exports